// extracted by mini-css-extract-plugin
module.exports = {"listItem":"PickupLocationSearch_listItem__2NpKr","searchIcon":"PickupLocationSearch_searchIcon__w-R11","locationIcon":"PickupLocationSearch_locationIcon__jeVd7"};